<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Evaluasi Pelaksanaan">
            <common-training-header :in-header="true" :withUser="false" />
        </a-page-header>
    </div>
</template>
<script>
export default
{

}
</script>
